import React from "react";

import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";

import { Button } from "@material-ui/core";

import SvgI24Details from "assets/icons/I24Details";
import SvgI24Edit from "assets/icons/I24Edit";

import PublishStatus from "components/PublishStatus";

import {
  getPublishButtonIcon,
  getPublishButtonTextWithout,
} from "utils/publish";

import {
  Container,
  ImageContainer,
  DetailsContainer,
  BottomControlsContainer,
  ControlWrapper,
  Menu,
  MenuContent,
  MenuContentWrapper,
  TextContainer,
} from "./styles";
import SvgI24Menu from "assets/icons/I24Menu";

type Props = {
  image: string;
  publishStatus: string;
  isDragging?: boolean;
  onEdit: () => void;
  onPublish: () => void;
  dragHandleProps?: DraggableProvidedDragHandleProps;
};

class GreetingCard extends React.Component<Props> {
  render() {
    const {
      image,
      publishStatus,
      isDragging,
      onEdit,
      onPublish,
      dragHandleProps,
    } = this.props;

    return (
      <Container isDragging={isDragging}>
        <ImageContainer image={image} />
        <DetailsContainer>
          <TextContainer></TextContainer>
          <BottomControlsContainer>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Edit />}
                variant="text"
                color="secondary"
                onClick={onEdit}
              >
                Edit
              </Button>
            </ControlWrapper>
            <ControlWrapper isPublishControl>
              <Button
                startIcon={getPublishButtonIcon(publishStatus)}
                variant="text"
                color="secondary"
                onClick={onPublish}
              >
                {getPublishButtonTextWithout(publishStatus)}
              </Button>
            </ControlWrapper>
          </BottomControlsContainer>
        </DetailsContainer>
        <MenuContent>
          <MenuContentWrapper>
            <PublishStatus status={publishStatus} />
          </MenuContentWrapper>
          {dragHandleProps && (
            <MenuContentWrapper>
              <Menu {...dragHandleProps}>
                <SvgI24Menu />
              </Menu>
            </MenuContentWrapper>
          )}
        </MenuContent>
      </Container>
    );
  }
}

export default GreetingCard;
